/**
 * Browser-wide "a session just started" signal. Every tab shares the auth
 * cookie, so a login in one tab revives every tab; this tells the others
 * (and other listeners in the same tab) without waiting for their own probes.
 *
 * Each announce opens its own channel because BroadcastChannel never delivers
 * to the instance that posted, and same-tab listeners must hear it too.
 */

const CHANNEL_NAME = 'erp-auth-session'
const SESSION_STARTED = 'session_started'

function openChannel(): BroadcastChannel | null {
    if (typeof BroadcastChannel === 'undefined') return null
    return new BroadcastChannel(CHANNEL_NAME)
}

export function announceSessionStarted(): void {
    const channel = openChannel()
    if (!channel) return
    channel.postMessage(SESSION_STARTED)
    channel.close()
}

/** Calls `listener` on every announced login. Returns an unsubscribe. */
export function onSessionStarted(listener: () => void): () => void {
    const channel = openChannel()
    if (!channel) return () => {}
    channel.onmessage = (event: MessageEvent) => {
        if (event.data === SESSION_STARTED) listener()
    }
    return () => channel.close()
}
